export default {
  regionalRiskAssessment: {
    eudrDueDiligence: "Diligence Raisonnable EUDR",
    title: "Évaluation des Risques Régionaux",
    titleTT: "Évaluation des risques régionaux de l'EUDR par comparaison des pays",
    details: "Détails",
    detailsTT: "Développer pour voir les critères détaillés et les références liées à la classification à haut risque, en se concentrant sur la déforestation, les droits des indigènes, la corruption et les questions de droits de l'homme",
    createNewCountryReport: "Créer un Nouveau Rapport de Pays",
    updateCountryReport: "Mettre à Jour le Rapport de Pays",
    duplicateCountryReport: "Dupliquer le Rapport de Pays",
    search: "Rechercher",
    country: "Pays",
    dateCreated: "Date de Création",
    edit: "Éditer",
    delete: "Supprimer",
    duplicate: "Dupliquer",
    actions: "Actes",
    submit: "Soumettre",
    save: "Enregistrer",
    cancel: "Annuler",
    selectCountry: "Sélectionner le Pays",
    riskAssessmentCriteria: "Critères d'Évaluation des Risques",
    riskLevel: "Niveau de Risque",
    unassigned: "Non Assigné",
    standard: "Standard",
    standardToHigh: "Standard à Élevé",
    high: "Élevé",
    reportDetails: "Détails du Rapport",
    select: "Sélectionner",
    requiredFields: "Ce champ est requis",
    pleaseFillRequiredFields: "Veuillez remplir tous les champs requis",
    createCuccess: "Évaluation des risques régionaux créée avec succès",
    updateSuccess: "Évaluation des risques régionaux mise à jour avec succès",
    createError: "Erreur lors de la création de l'évaluation des risques régionaux",
    updateError: "Erreur lors de la mise à jour de l'évaluation des risques régionaux",
    deleteSuccess: "Évaluation des risques régionaux supprimée avec succès",
    duplicateSuccess: "Évaluation des risques régionaux dupliquée avec succès",
    deleteRegionalRisk: "Supprimer l'Évaluation des Risques Régionaux",
    confirmDelete: "Êtes-vous sûr de vouloir supprimer cette évaluation des risques régionaux ?",
    confirm: "Confirmer",
    saveSuccess: "Évaluation des risques régionaux enregistrée avec succès",
    fetchError: "Erreur lors de la récupération de l'évaluation des risques régionaux",
    disregard: "Ignorer les Segments",
    addRegionalRiskAssessment: "Ajouter une Évaluation des Risques Régionaux",
    summary: "Résumé",
    summaryTT: "Cette section décrit les niveaux de risque assignés en fonction de données et de références complètes.",
    summaryText: "L'évaluation des risques par pays classera le pays de la ferme selon les niveaux de risque suivants (Élevé, Standard et Zéro/Négligeable) en fonction de références vérifiables, d'informations, de documents et de données. Des résultats différents de « Zéro/Négligeable » indiqueront la nécessité de certaines actions d'atténuation des risques (RMA) pour garantir un « Risque Zéro/Négligeable ». Le Tableau 1 montre les résultats globaux de l'évaluation des risques pour (pays). L'évaluation complète des risques par pays est jointe à ce document dans l'Annexe III.",
    disregardConfirmTitle: "Ignorer Un ou Tous les Segments",
    addConfirmTitle: "Ajouter Un ou Tous les Segments",
    selectSegment: "Sélectionner les segments à ignorer.",
    deselectToAddSegment: "Désélectionner les segments à ajouter.",
    all: "Tous",
    protectedAreas: "Zones Protégées & Indigènes",
    verificaton: "Vérification avec la Base de Données du Gouvernement Brésilien",
    confirmation: "Confirmation",
    confirmationMessage: "Êtes-vous sûr de vouloir ignorer l'évaluation des risques régionaux ? Confirmer cette action entraînera la suppression de l'évaluation des risques régionaux du rapport de diligence raisonnable.",
    noSegmentSelectedMessage: "Aucun segment sélectionné. Veuillez sélectionner un segment pour continuer.",
    singleRiskAssessmentCriteriaMessage: "Êtes-vous sûr de vouloir ajouter ou supprimer les Critères d'Évaluation des Risques Régionaux ? Confirmer cette action mettra à jour le rapport de diligence raisonnable en conséquence.",
    singleProtectedAreasMessage: "Êtes-vous sûr de vouloir ajouter ou supprimer les Zones Protégées et Indigènes ? Confirmer cette action mettra à jour le rapport de diligence raisonnable en conséquence.",
    bothSegmentsMessage: "Êtes-vous sûr de vouloir ajouter ou supprimer à la fois les Critères d'Évaluation des Risques Régionaux et les Zones Protégées et Indigènes ? Confirmer cette action mettra à jour le rapport de diligence raisonnable en conséquence.",
    segmentsUpdatedSuccessfully: "Segments mis à jour avec succès"
  },
};
